import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RangeValue } from "../../components/Employees/EmployeePerformance";

interface InitialState {
  departmentLists: string[];
  designationLists: string[];
  rangeValue: RangeValue;
  rangeValue1: RangeValue;
  search?: string;
}

const initialState: InitialState = {
  departmentLists: [],
  designationLists: [],
  rangeValue: [0, 100],
  rangeValue1: [0, 100],
  search: "",
};

const employeePerformanceSlice = createSlice({
  name: "employeePerformance",
  initialState,
  reducers: {
    setDepartmentListsPerformance: (state, action: PayloadAction<string[]>) => {
      state.departmentLists = action.payload;
    },
    setDesignationListsPerformance: (
      state,
      action: PayloadAction<string[]>
    ) => {
      state.designationLists = action.payload;
    },
    setRangeValueListsPerformance: (
      state,
      action: PayloadAction<RangeValue>
    ) => {
      state.rangeValue = action.payload;
    },
    setRangeValueLists1Performance: (
      state,
      action: PayloadAction<RangeValue>
    ) => {
      state.rangeValue1 = action.payload;
    },
    setSearchPerformance: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    resetEmployeePerformance: () => initialState,
  },
});

export const {
  setDepartmentListsPerformance,
  setDesignationListsPerformance,
  setRangeValueListsPerformance,
  setRangeValueLists1Performance,
  setSearchPerformance,
  resetEmployeePerformance,
} = employeePerformanceSlice.actions;
export default employeePerformanceSlice.reducer;
